import * as angular from 'angular';
import { Observable } from 'rxjs';
import { ReportViewerFacade } from '@mode/report-viewer/domain';

class ReportNotebookController implements angular.IOnInit {
  static $inject = ['ReportViewerFacade'];

  hasRun$: Observable<boolean>;

  constructor(private reportViewerFacade: ReportViewerFacade) {}

  $onInit(): void {
    this.hasRun$ = this.reportViewerFacade.hasRun$;
  }
}

export const ID = 'reportNotebook';

export const reportNotebook: angular.IComponentOptions = {
  template: `
    <div class="report-query-view">
      <div class="code-container">
        <notebook-view ng-if="ctrl.hasRun$ | async:this"></notebook-view>
      </div>
    </div>
  `,
  controller: ReportNotebookController,
  controllerAs: 'ctrl',
};
